// 'use client';
// import { useAuth } from '@/features/authentication/hooks/auth';
// import { useAppDispatch } from '@/lib/redux/hooks';
// import React, { useEffect, useRef } from 'react';
// import { login, logout } from '@/lib/redux/features/userSlice';
// import useCart from '@/hooks/useCart';
// import { getLocalCart } from '@/lib/redux/features/localCart';
// import { usePathname } from 'next/navigation';

// const CheckUser = () => {
//   const dispatch = useAppDispatch();
//   const pathName = usePathname();
//   const { addAllCart } = useCart();
//   const { user, isLoading } = useAuth();

//   // 👉 This blocks ALL repeated calls
//   const callCount = useRef(0);

//   useEffect(() => {
//     // Stop immediately if already executed
//     if (callCount.current > 0) return;
//     console.log(callCount);

//     if (!isLoading && user) {
//       dispatch(login());

//       const cart = getLocalCart() || [];

//       if (cart.length > 0 && !pathName?.includes('checkout')) {
//         callCount.current = callCount.current + 1; // lock it here

//         const addCartFunctionCall = async () => {
//           await addAllCart();
//         };

//         addCartFunctionCall();
//         console.log('addCartFunctionCall - run once');
//       }
//     } else {
//       dispatch(logout());
//     }
//   }, [user, isLoading]);

//   return null;
// };

// export default CheckUser;

// 💡 Move this outside the component so strict mode cannot reset it

'use client';

// 💡 Module-level variable (survives strict mode remount)
let hasRunOnce = false;

import { useAuth } from '@/features/authentication/hooks/auth';
import { useAppDispatch } from '@/lib/redux/hooks';
import { useEffect } from 'react';
import { login, logout } from '@/lib/redux/features/userSlice';
import useCart from '@/hooks/useCart';
import { getLocalCart } from '@/lib/redux/features/localCart';
import { usePathname } from 'next/navigation';

const CheckUser = () => {
  const dispatch = useAppDispatch();
  const pathName = usePathname();
  const { addAllCart } = useCart();
  const { user, isLoading } = useAuth();

  useEffect(() => {
    if (isLoading) return;

    if (user) {
      dispatch(login());

      // 🔥 Fires only ONCE per page load
      if (!hasRunOnce) {
        hasRunOnce = true;

        const cart = getLocalCart() || [];
        if (cart.length > 0 && !pathName.includes('checkout')) {
          console.log('CALL ONE TIME ONLY');
          addAllCart();
        }
      }
    } else {
      dispatch(logout());
    }
  }, [user, isLoading]);

  return null;
};

export default CheckUser;
